import { render, staticRenderFns } from "./Trashcan.vue?vue&type=template&id=6e162fe2&scoped=true&"
import script from "./Trashcan.vue?vue&type=script&lang=ts&"
export * from "./Trashcan.vue?vue&type=script&lang=ts&"
import style0 from "./Trashcan.vue?vue&type=style&index=0&id=6e162fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e162fe2",
  null
  
)

export default component.exports